import styled from 'styled-components';
import { CheckOutlined } from '@ant-design/icons';

const StyledCheckOutlined = styled(CheckOutlined)`
    fontsize: 16px;
    padding-bottom: 5px;
`;

export default StyledCheckOutlined;
